import documentFilters from "../filters/documents";
import useModel from "./useModel";
import { CultureObject } from "../models/Culture";
import useModelFilter from "./useModelFilter";
import useUrlFilter from "./useUrlFilter";
import { CountDocumentsDocument } from "../graphql/generated/types";

const useDocumentsFilter = () => {
  const culturesModel = useModel<CultureObject>("culturas");
  const filters = useModelFilter(
    documentFilters,
    [
      async () =>
        culturesModel.search({}).then((res) => [
          "culture",
          res.map((culture) => ({
            value: culture._id,
            label: culture.name!,
            filter: { cultureId: culture._id },
          })),
        ]),
    ],
    CountDocumentsDocument
  );

  useUrlFilter(filters);

  return filters;
};

export default useDocumentsFilter;
